import { Component, OnInit } from '@angular/core';
import { CorreiosAuth, CorreiosServices } from 'src/app/services/correios.services';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import xmlTojson from 'src/app/script/xmlTojson';
import { GlobalErrorHandler } from 'src/app/services/GloabalErrorHandler.services';
import { UserConfigServices } from 'src/app/services/user-config.services';
import { Subject } from 'rxjs';


@Component({
    selector: 'app-painel-correios',
    templateUrl: './painel-correios.component.html',
    styleUrls: ['./painel-correios.component.scss'],
    standalone: false
})
export class PainelCorreiosComponent implements OnInit {

  constructor(public uid:UserAuthenticationServices, 
  private http:HTTPService,
  private cs:CorreiosServices,
  private ucs:UserConfigServices
  ) { }
  codecompany:number = 0;
  codecontract:number = 0;
  correiosAuth:CorreiosAuth = null;
  enablePanels:boolean = false;
  listServices:Object[] = [];
  servico:Object = null;
  userConfig = {};
  eventsSubject: Subject<object> = new Subject<object>();

  ngOnInit(): void {
      
      if  ( this.uid.user.companylist.length == 1 ){
        this.codecompany = Number(this.uid.user.companylist[0].codecompany);
        this.codecontract = Number(this.uid.user.companylist[0].codecontract)
        this.loadCredential(null);  
      } 
  }

  loadCredential(data){
    
    if ( data ){
        this.codecontract = data['codecontract'];
    }

    this.ucs.loadUserConfig(this.uid.user.iduser,'Mktpetqrange').subscribe(data=>{
      if (ObjectUtil.isNotEmpty(data['Mktpusercfg'][0]) ){
        if ( ObjectUtil.isNotEmpty(data['Mktpusercfg'][0]['CONFIG'])){
            this.userConfig = JSON.parse(data['Mktpusercfg'][0]['CONFIG']);
        }
      }
      this.eventsSubject.next(this.userConfig);
    });

    let ob = {
      "entityName":"Mktpactivecompanies",
      "sql":`SELECT A.APIUSERNAME, A.APIPASSWORD, A.APIKEY, B.CNPJ
            FROM MKTPACTIVECOMPANIES A INNER JOIN MKTPCOMPANIES B ON A.CODECOMPANY=B.CODECOMPANY
            WHERE A.CODECOMPANY=${this.codecompany}
            AND A.CODEMKTP=87
            AND A.STATUS=1
            AND A.ENVIRONMENT=1`
    }
     
    this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
         
        if( ObjectUtil.isNotEmpty(con['SQL'])){

          let apiKey:string  = con['SQL'][0]['APIKEY'];
          let codcontrato:string = '';
          let codadm:string = '';
          let codcartao:string ='';
          let usernameTrack:string = '';
          let passwordTrack:string ='';

          if ( apiKey.split(";").length == 3 ){
            codcontrato = apiKey.split(";")[0];
            codadm = apiKey.split(";")[1];
            codcartao = apiKey.split(";")[2];
          }else{
            if ( apiKey.split(";").length == 5 ){
              codcontrato = apiKey.split(";")[0];
              codadm = apiKey.split(";")[1];
              codcartao = apiKey.split(";")[2];
              usernameTrack = apiKey.split(";")[3];
              passwordTrack = apiKey.split(";")[4];
            }else{
              throw Error('Estrutra do API Key deve ser Cód.Contrato;Cód. Adm;Cód. Cartão');
            }
            
          }
          

          this.correiosAuth = {
              username: con['SQL'][0]['APIUSERNAME'],
              password: con['SQL'][0]['APIPASSWORD'],
              codadm: codadm,
              codcartao: codcartao,
              codcontrato: codcontrato,
              cnpj: con['SQL'][0]['CNPJ'],
              usernameTrack: usernameTrack,
              passwordTrack: passwordTrack
          }
  
          var x2js  = new xmlTojson();
          this.enablePanels = true;          
          this.cs.getCliente(this.codecompany,this.codecontract,this.correiosAuth).then(data=>{
              let doc:Document = new DOMParser().parseFromString(data as string,'text/xml');
              let result = doc.evaluate("//return//servicos",doc);
              let nodes = result.iterateNext();
              while(nodes){
                var jsonData =  x2js.xml2json(nodes);
                
                this.listServices.push(jsonData);
                nodes = result.iterateNext();
              }
              
              this.listServices.sort((a,b)=>{
                  
                  if ( a['descricao'] > b['descricao']){
                    return 1;
                  }

                  if ( a['descricao'] < b['descricao']){
                    return -1;
                  }

                  return 0;
              });

          }).catch(error=>{
            GlobalErrorHandler.showError(error);
          });

        }else{
          this.enablePanels = false;
          throw Error('Empresa não configurada para usar o serviço dos Correios.');
        }
    });
  }

}
